export enum LogType{
    None = 'None',
    Error = 'Error',
    Warning = 'Warning',
    Info = 'Info',
    Debug = 'Debug'
}
